{
    "coordinates": [
        3.9400434929205943,
        36.20134406162626
    ],
    "tooltip": "Koobi Fora",
    "title": "Koobi Fora",
    "country": "Kenya",
    "period": "Quaternary"
}
